<script>
import HrPayrollMark from "@/components/branding/hr-payroll-mark.vue";
import AuthService from "@/services/authService";
import { toast } from "@/utils/toast";
export default {
  components: { HrPayrollMark },
  data() {
    return {
      showPassword: false,
      showPassword1: false,
      email: "",
      token: "",
      password: "",
      password_confirmation: "",
      loading: false,
      resetComplete: false,
      serverMessage: "",
    };
  },
  mounted() {
    this.updateBodyClass();
    this.email = String(this.$route.query.email || "");
    this.token = String(this.$route.query.token || "");
  },
  watch: {
    // Watch for route changes
    $route() {
      this.updateBodyClass();
      this.email = String(this.$route.query.email || "");
      this.token = String(this.$route.query.token || "");
    },
  },
  computed: {
    isSetPasswordFlow() {
      return String(this.$route.path || "").includes("/set-password");
    },
    pageTitle() {
      return this.isSetPasswordFlow ? "Set Your Password" : "Reset Password";
    },
    pageSubtitle() {
      return this.isSetPasswordFlow
        ? "Choose a password to activate your portal access."
        : "Your new password must be different from previous used passwords.";
    },
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    buttonLabel1() {
      return this.showPassword1 ? "Hide" : "Show";
    },
  },
  methods: {
    updateBodyClass() {
      if (
        this.$route.path.includes("/reset-password") ||
        this.$route.path.includes("/set-password")
      ) {
        document.body.classList.add("bg-white");
      } else {
        document.body.classList.remove("bg-white");
      }
    },
    async submitForm() {
      this.serverMessage = "";

      if (!this.token || !this.email) {
        this.serverMessage = "This password link is invalid or incomplete.";
        toast(this.serverMessage, "error");
        return;
      }

      if (this.password !== this.password_confirmation) {
        this.serverMessage = "Passwords do not match.";
        toast(this.serverMessage, "error");
        return;
      }

      this.loading = true;
      try {
        const payload = {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
        };
        if (this.isSetPasswordFlow) {
          payload.broker = "invites";
        }

        const res = await AuthService.resetPasswordPublic(payload);
        this.resetComplete = true;
        this.serverMessage =
          res?.data?.message ||
          "Your password has been set successfully. You can now sign in.";
        toast(this.serverMessage);
        this.$router.push("/login");
      } catch (error) {
        const responseErrors = error?.response?.data?.errors;
        const message =
          responseErrors?.email?.[0] ||
          responseErrors?.password?.[0] ||
          error?.response?.data?.message ||
          "Failed to set password.";
        this.serverMessage = message;
        toast(message, "error");
      } finally {
        this.loading = false;
      }
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },
  },
};
</script>

<template>
  <div class="container-fuild">
    <div class="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
      <div class="row">
        <div class="col-lg-5">
          <div
            class="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100"
          >
            <div class="bg-overlay-img">
              <img src="@/assets/img/bg/bg-01.png" class="bg-1" alt="" />
              <img src="@/assets/img/bg/bg-02.png" class="bg-2" alt="" />
              <img src="@/assets/img/bg/bg-03.png" class="bg-3" alt="" />
            </div>
            <div class="authentication-card w-100">
              <div class="authen-overlay-item border w-100">
                <h1 class="text-white fs-40">
                  Empowering people <br />
                  through seamless HR <br />
                  management.
                </h1>
                <div class="my-4 mx-auto authen-overlay-img">
                  <img src="@/assets/img/bg/authentication-bg-01.png" alt="" />
                </div>
                <div>
                  <p class="text-white fs-20 fw-semibold text-center">
                    Efficiently manage your workforce, streamline <br />
                    operations effortlessly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-7 col-md-12 col-sm-12">
          <div
            class="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap"
          >
            <div class="col-md-7 mx-auto p-4">
              <form @submit.prevent="submitForm">
                <div>
                  <div class="mx-auto mb-5 text-center">
                    <hr-payroll-mark variant="full" />
                  </div>
                  <div class="">
                    <div class="text-center mb-3">
                      <h2 class="mb-2">{{ pageTitle }}</h2>
                      <p class="mb-0">
                        {{ pageSubtitle }}
                      </p>
                    </div>
                    <div
                      v-if="serverMessage"
                      class="alert"
                      :class="resetComplete ? 'alert-success' : 'alert-danger'"
                    >
                      {{ serverMessage }}
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Email Address</label>
                      <input
                        :value="email"
                        type="email"
                        class="form-control"
                        readonly
                      />
                    </div>
                    <div>
                      <div class="input-block mb-3">
                        <div class="mb-3">
                          <label class="form-label">Password</label>
                          <div class="pass-group" id="passwordInput">
                            <input
                              :type="showPassword ? 'text' : 'password'"
                              v-model="password"
                              class="pass-input form-control"
                              autocomplete="new-password"
                              required
                            />
                            <span
                              @click="toggleShow"
                              class="ti toggle-password"
                              :class="{
                                'ti-eye': showPassword,
                                'ti-eye-off': !showPassword,
                              }"
                            ></span>
                          </div>
                        </div>
                        <div class="password-strength d-flex" id="passwordStrength">
                          <span id="poor"></span>
                          <span id="weak"></span>
                          <span id="strong"></span>
                          <span id="heavy"></span>
                        </div>
                        <div id="passwordInfo" class="mb-2"></div>
                        <p class="fs-12">
                          Use 8 or more characters with a mix of letters, numbers &
                          symbols.
                        </p>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Confirm Password</label>
                        <div class="pass-group">
                          <input
                            :type="showPassword1 ? 'text' : 'password'"
                            v-model="password_confirmation"
                            class="pass-inputs form-control"
                            autocomplete="new-password"
                            required
                          />
                          <span
                            @click="toggleShow1"
                            class="ti toggle-passwords"
                            :class="{
                              'ti-eye': showPassword1,
                              'ti-eye-off': !showPassword1,
                            }"
                          ></span>
                        </div>
                      </div>
                      <div class="mb-3">
                        <button type="submit" class="btn btn-primary w-100">
                          {{
                            loading
                              ? isSetPasswordFlow
                                ? "Saving..."
                                : "Resetting..."
                              : isSetPasswordFlow
                              ? "Set Password"
                              : "Submit"
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mt-5 text-center">
                    <p class="mb-0 text-gray-9">
                      2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR &amp; Payroll
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

